<template>
	<div class="mt-4">
		
		<b-container class=" mt-2" fluid="xl">
			<FeedbackMessage />
		</b-container>
			<h4>{{$t('dashboard')}}</h4>

			<b-container fluid="lg" class="my-4 py-4">
				<div class="row">
    			<div class="col col-xl-8 app-panel bg-white mx-2 px-4 my-2">
						<b-form v-on:submit.prevent="">
							<b-row class="form-group">
								<b-col lg class="text-sm-right text-left">
									<b-form-group
										id="nlcd-username" label-class="font-weight-bold"
										label-cols-sm="4" label-cols-lg="3" 
										:label="$t('label.bic')"
										:description="$t('label.bic.description')"
										label-for="bic"
									>
										<b-form-input id="ibic" v-model="bic"
										:placeholder="$t('label.bic.placeholder')" :state="stateBIC"
										type="text"   aria-describedby="invalid-feedback-bic valid-feedback-bic" />
										<b-form-invalid-feedback id="invalid-feedback-bic">{{$t('bic.invalid.text')}}</b-form-invalid-feedback>
										<b-form-valid-feedback id="valid-feedback-bic">{{$t('bic.valid.text')}}</b-form-valid-feedback>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-group">
								<b-col lg class="text-sm-right text-left">
									<b-form-group
										id="rcpt" label-class="font-weight-bold"
										label-cols-sm="4" label-cols-lg="3" 
										:label="$t('label.receipient')"
										:description="$t('label.receipient.description')"
										label-for="input-rcpt" 
									>
										<b-form-input id="input-rcpt"  v-model="receipient" :state="stateReceipient"
										:placeholder="$t('label.receipient.placeholder')"
											autocomplete="false" type="text" aria-describedby="invalid-feedback-receipient" />
										<b-form-invalid-feedback id="invalid-feedback-receipient">{{$t('receipient.invalid.text')}}</b-form-invalid-feedback>
									
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-group">
								<b-col lg class="text-sm-right text-left">
									<b-form-group
										id="iban" label-class="font-weight-bold"
										label-cols-sm="4" label-cols-lg="3" 
										:label="$t('label.iban')"
										:description="$t('label.iban.description')"
										label-for="input-iban" 
									>
										<b-form-input id="input-iban"  v-model="iban" :state="stateIBAN"
										:placeholder="$t('label.iban.placeholder')"
											autocomplete="false" type="text" aria-describedby="invalid-feedback-iban valid-feedback-iban" />
										<b-form-invalid-feedback id="invalid-feedback-iban">{{$t('iban.invalid.text')}}</b-form-invalid-feedback>
										<b-form-valid-feedback id="valid-feedback-bic">{{$t('iban.valid.text')}}</b-form-valid-feedback>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-group">
								<b-col lg class="text-sm-right text-left">
									<b-form-group
										id="betrag" label-class="font-weight-bold"
										label-cols-sm="4" label-cols-lg="3" 
										:label="$t('label.betrag')"
										:description="$t('label.betrag.description')"
										label-for="input-betrag" 
									>
										<b-form-input id="input-betrag"  v-model="betrag" :state="stateBetrag"
										:placeholder="$t('label.betrag.placeholder')"
											autocomplete="false" type="number" aria-describedby="invalid-feedback-betrag" />
										<b-form-invalid-feedback id="invalid-feedback-betrag">{{$t('betrag.invalid.text')}}</b-form-invalid-feedback>
									
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-group">
								<b-col lg class="text-sm-right text-left">
									<b-form-group
										id="referenz" :label-class="labelClassReferenz"
										label-cols-sm="4" label-cols-lg="3" 
										:label="$t('label.referenz')"
										:description="$t('label.referenz.description')"
										label-for="input-referenz" 
									>
										<b-form-input id="input-referenz"  v-model="referenz" :state="stateReferenz"
										:placeholder="$t('label.referenz.placeholder')"
											autocomplete="false" type="text" aria-describedby="invalid-feedback-referenz" />
										<b-form-invalid-feedback id="invalid-feedback-referenz">{{$t('referenz.invalid.text')}}</b-form-invalid-feedback>
									
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-group">
								<b-col lg class="text-sm-right text-left">
									<b-form-group
										id="verwendungszweck" :label-class="labelClassVerwendungszweck"
										label-cols-sm="4" label-cols-lg="3" 
										:label="$t('label.verwendungszweck')"
										:description="$t('label.verwendungszweck.description')"
										label-for="input-verwendungszweck" 
									>
										<b-form-input id="input-verwendungszweck"  v-model="verwendungszweck" :state="stateVerwendungszweck"
										:placeholder="$t('label.verwendungszweck.placeholder')"
											autocomplete="false" type="text" aria-describedby="invalid-feedback-verwendungszweck" />
										<b-form-invalid-feedback id="invalid-feedback-verwendungszweck">{{$t('verwendungszweck.invalid.text')}}</b-form-invalid-feedback>
									
									</b-form-group>
								</b-col>
							</b-row>
						</b-form>
						<div>
							<b-btn variant="light" :disabled="!saveTemplateEnabled" class="mb-4 mr-2"  @click="saveTemplate()">{{$t('button.save.template')}}</b-btn>		
							<b-btn variant="info" v-if="isShowLoadTemplate" class="mb-4"  @click="loadTemplate()">{{$t('button.load.template')}}</b-btn>		
						</div>
					</div>
					<div class="col-xl app-panel bg-white mx-2 px-4 my-2">
						<b-alert :show="showEitherWarning" variant="warning">{{$t('warning.either.referenz.verwendungszweck')}}</b-alert>	
						<b-alert :show="showOrWarning" variant="secondary">{{$t('warning.or.referenz.verwendungszweck')}}</b-alert>	
						<div class="text-center ">
							<h5>EPC QRCode</h5>
							<div class="mx-5 py-4 bg-white">
								<qrcode-vue id="qrbarcode" class="d-inline-block"  :value="contentOfQRCode" />
									
							</div>
						<b-alert show variant="info">{{$t('tip.copy.image')}}</b-alert>	
							<div>
								<h5>{{$t('epc.qrcode.content')}}</h5>
								<b-textarea disabled rows="12" :value="contentOfQRCode">
								
								</b-textarea>


							</div>
						</div>	
					</div>
				</div>
		</b-container>
		<b-btn variant="primary" class="mb-4"  @click="scanQRCode()">{{$t('button.scan.epcqrcode')}} <datamatrix-scan-icon :size="18" />
		</b-btn>			
		<AccountTemplates id="accountTemplatesModal" />			
		<QrCodeModal id="scanEPCQrCodeModal" :onBarcodeDetected="qrCodefound" 
						:subject="$t('epc.qrcode.scan.subject')" 
						:title="$t('epc.qrcode.scan.title')" />
	</div>	
</template>

<script>
import FeedbackMessage from '../FeedbackMessage'
import moment from 'moment'
import momentDurationFormatSetup from "moment-duration-format"
import DatamatrixScanIcon from 'vue-material-design-icons/DataMatrixScan'
import { mapGetters, mapState } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import QrCodeModal from '../qrcodereader/QrCodeModal'
import AccountTemplates from '../AccountTemplates.vue'
import { recognizeEPCQrcode } from './epcQrcodeUtil'


export default {
	components : { FeedbackMessage, QrcodeVue, QrCodeModal, DatamatrixScanIcon, AccountTemplates },

	computed:{
		...mapGetters(['contentOfQRCode', 'stateVerwendungszweck', 'stateBIC', 'stateReceipient', 'stateIBAN', 
			'stateReferenz', 'stateBetrag', 'isShowLoadTemplate'
	]),
		showEitherWarning(){ 
			return !!this.$store.getters.referenz && !!this.$store.getters.verwendungszweck},
		showOrWarning(){ 
			return !this.$store.getters.referenz && !this.$store.getters.verwendungszweck},	
		labelClassReferenz() {
			return( !!this.$store.getters.referenz && !this.$store.getters.verwendungszweck)?'font-weight-bold':''
		},
		saveTemplateEnabled(){
			return this.$store.getters.stateIBAN && this.$store.getters.receipient
		},
		labelClassVerwendungszweck() {
			return( !this.$store.getters.referenz && !!this.$store.getters.verwendungszweck)?'font-weight-bold':''
		},
		
		bic: {
				get () {
					return this.$store.getters.bic
				},
				set (value) {
					this.$store.commit('bic', value)
			}
    },
		receipient: {
				get () {
					return this.$store.getters.receipient
				},
				set (value) {
					this.$store.commit('receipient', value)
			}
    },
		iban: {
				get () {
					return this.$store.getters.iban
				},
				set (value) {
					this.$store.commit('iban', value)
			}
    },
		betrag: {
				get () {
					return this.$store.getters.betrag
				},
				set (value) {
					this.$store.commit('betrag', value)
			}
    },
		referenz: {
				get () {
					return this.$store.getters.referenz
				},
				set (value) {
					this.$store.commit('referenz', value)
			}
    },
		verwendungszweck: {
				get () {
					return this.$store.getters.verwendungszweck
				},
				set (value) {
					this.$store.commit('verwendungszweck', value)
			}
    },
		hinweis: {
				get () {
					return this.$store.getters.hinweis
				},
				set (value) {
					this.$store.commit('hinweis', value)
			}
    },
	},
	methods:{
		scanQRCode(){
			this.$bvModal.show("scanEPCQrCodeModal")
			
		},
		loadTemplate(){
			this.$bvModal.show("accountTemplatesModal")
			
		},
		qrCodefound(decodedString){
			this.$bvModal.hide('scanEPCQrCodeModal')
			console.debug('scannedString:', decodedString)
			const result = recognizeEPCQrcode(decodedString)
			if(result.isLeft){
				console.log('is left', result)
				this.$bvToast.toast(result.value, {
						title: this.$t('scan.epcqrcode.nok.title'),
						autoHideDelay: 3200,
						variant:'warning'
						})
				
			}else{
				const data = result.value

				this.$store.commit('bic', data.bic)
				this.$store.commit('betrag', data.betrag)
				this.$store.commit('iban', data.iban)
				this.$store.commit('receipient', data.receipient)
				this.$store.commit('referenz', data.referenz)
				this.$store.commit('verwendungszweck', data.verwendungszweck)
				this.$store.commit('hinweis', data.hinweis)

				this.$bvToast.toast(this.$t('scan.epcqrcode.ok.title'), {
							title: this.$t('scan.epcqrcode.ok.title'),
							autoHideDelay: 5200,
							variant:'success'
							})
			}
		
		},
		saveTemplate(){
			this.$store.dispatch('saveAsTemplate')
		}
	}

}
</script>
<style>
.with-header-offset{
	padding-top: 69px;
}
</style>